import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getFirstName } from 'src/modules/user/selectors/userSelectors';

import { usePathwaysNavigation } from '../hooks/navigation';
import { CreatePathwayLayout } from '../components/CreatePathwayLayout';

export const PathwayCreateIntroPage = () => {
    const { navigate } = usePathwaysNavigation();
    const { uuid } = useParams<{ uuid: string }>();
    const { t } = useTranslation();
    const firstName = useSelector(getFirstName);

    return (
        <CreatePathwayLayout
            subtitle={t('pathways:onboarding.intro.subtitle', { name: firstName })}
            title={t('pathways:onboarding.intro.title')}
            description={t('pathways:onboarding.intro.description')}
            buttonText={t('pathways:action.continue')}
            onSubmit={() => navigate.createPathwayQuestionnaire({ uuid })}
            onClose={() => navigate.pathway({ uuid })}
        />
    );
};
